import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="w-full bg-white py-8 px-4" data-id="element-105">
      <div className="max-w-2xl mx-auto text-center" data-id="element-106">
        <p className="uppercase tracking-widest mb-4 text-[#D89DC5] text-[20px] font-[900]" data-id="element-107">
          Kit Aprendizaje en Casa
        </p>

        <h1 className="md:text-5xl font-black text-black mb-5 text-[24px]" data-id="element-108">
          Las tareas no deberían terminar en pelea
        </h1>

        <a href="#compra" className="block max-w-md mx-auto mb-6" data-id="element-109">
          <img src="https://cdn.magicpatterns.com/uploads/3mRA1Ko1NkmoaHw525cMP3/Gemini_Generated_Image_a8wgzma8wgzma8wg_(1).png" alt="Kit de Aprendizaje en Casa" className="w-full h-auto rounded-lg" data-id="element-110" />
        </a>

        <h2 className="text-2xl md:text-3xl font-black text-red-600 mb-5 leading-snug" data-id="element-111">
          Ayudá a tu hijo sin frustrarte (aunque no sepas cómo explicarle)
        </h2>

        <p className="text-lg md:text-xl text-gray-700 mb-6 leading-relaxed" data-id="element-112">
          Cuando entendés qué hacer en cada momento, todo cambia: menos
          discusiones, más calma y más confianza.
        </p>

        <CTAButton text="👉 QUIERO AYUDAR A MI HIJO SIN PELEAS" href="#compra" className="w-full" data-id="element-113" />

        <p className="mt-6 text-base font-bold text-gray-500 tracking-wide" data-id="element-114">
          ✔ Acceso inmediato ✔ Descarga digital    ✔ Aplicación desde hoy
        </p>
      </div>
    </section>;
}